module.exports = __webpack_public_path__ + "static/media/max-payne.d0843a25.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Videos/max-payne.webm
// module id = 55
// module chunks = 0